import Rails from 'rails-ujs'
import { domReady } from '../utils'

const initRailsUjs = () => Rails.start()

// export default domReady(initRailsUjs)
export default domReady(initRailsUjs)